export default __webpack_public_path__ + "static/EuropeanWaxCenter-cc3ff7e5af6e23fc5426a1e2ffbb3fc7.png";